export const header = `shadow-sm -mx-4 -mt-4 p-4`;

export const content = `py-4 -mr-4 -mb-4 pr-4 flex flex-col grow gap-0.5 overflow-y-scroll`;
